export default __webpack_public_path__ + "static/media/play-button.2cd0d737.svg";